// src/components/GoogleSignInButton.jsx
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

/**
 * Self-contained Google Sign-In Button that can be placed anywhere
 * 
 * @param {Object} props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.buttonText="Sign in with Google"] - Button text (deprecated)
 * @param {function} [props.onSuccess] - Callback function when sign-in succeeds
 * @param {function} [props.onError] - Callback function when sign-in fails
 * @param {boolean} [props.iconOnly=false] - Show only icon without text
 * @param {string} [props.buttonSize="md"] - Button size (sm, md, lg)
 * @param {ReactNode} [props.children] - Button content
 * @returns {JSX.Element}
 */
function GoogleSignInButton({
  className = "",
  buttonText = "Customize with AI",
  onSuccess = () => { },
  onError = () => { },
  iconOnly = false,
  buttonSize = "md",
  children
}) {
  const [loading, setLoading] = useState(false);
  const { signInWithGoogle } = useAuth();

  const sizeClasses = {
    sm: "btn-sm",
    md: "",
    lg: "btn-lg"
  };

  const buttonClass = `btn ${sizeClasses[buttonSize]} ${iconOnly ? 'btn-circle' : ''} ${className}`;

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);
      const result = await signInWithGoogle();
      onSuccess(result.user, result); // Pass both user and full result
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  // Google logo SVG
  const GoogleIcon = () => (
    <svg width={iconOnly ? "20" : "18"} height={iconOnly ? "20" : "18"} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032 s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2 C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"
      />
    </svg>
  );

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={loading}
      className={buttonClass}
    >
      {loading ? (
        <span className="loading loading-spinner"></span>
      ) : (
        <>
          {/* <GoogleIcon /> */}
          {!iconOnly && (
            <span>
              {children || buttonText}
            </span>
          )}
        </>
      )}
    </button>
  );
}

export default GoogleSignInButton;
